"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useConfirmedAction_1 = __importDefault(require("./useConfirm/useConfirmedAction"));
var icons_1 = require("../icons");
var buildObjectMessage = function (namedObjects, objectName, pluralObjectName) {
    if (namedObjects.length === 1 && namedObjects[0].name) {
        return objectName + " \"" + namedObjects[0].name + "\"";
    }
    return namedObjects.length.toLocaleString() + " " + (pluralObjectName || objectName + 's');
};
function useDeleteObjects(_a) {
    var _this = this;
    var deleteObject = _a.deleteObject, bulkDeleteObjects = _a.bulkDeleteObjects, objectName = _a.objectName, pluralObjectName = _a.pluralObjectName, dialog = _a.dialog, successToast = _a.successToast, errorToast = _a.errorToast, rest = __rest(_a, ["deleteObject", "bulkDeleteObjects", "objectName", "pluralObjectName", "dialog", "successToast", "errorToast"]);
    var _b = useConfirmedAction_1.default(__assign(__assign({}, rest), { action: function (namedObjects) { return __awaiter(_this, void 0, void 0, function () {
            var ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = namedObjects.map(function (o) { return o.id; });
                        if (!bulkDeleteObjects) return [3 /*break*/, 2];
                        return [4 /*yield*/, bulkDeleteObjects(ids)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!deleteObject) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all(ids.map(function (id) { return deleteObject(id); }))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); }, dialog: function (namedObjects) { return (__assign({ type: 'error', title: "Delete " + buildObjectMessage(namedObjects, objectName, pluralObjectName) + "?", confirmText: 'Delete', icon: icons_1.Trash }, (typeof dialog === 'function' ? dialog(namedObjects) : dialog))); }, successToast: function (namedObjects) { return (__assign({ type: 'icon', icon: icons_1.CheckCircle, iconColor: 'Success', title: "Successfully deleted " + buildObjectMessage(namedObjects, objectName, pluralObjectName) }, (typeof successToast === 'function' ? successToast(namedObjects) : successToast))); }, errorToast: function (namedObjects) { return (__assign({ type: 'icon', icon: icons_1.AlertTriangle, iconColor: 'Error', title: "Error deleting " + buildObjectMessage(namedObjects, objectName, pluralObjectName) }, (typeof errorToast === 'function' ? errorToast(namedObjects) : errorToast))); } })), action = _b.action, renderedDialog = _b.renderedDialog;
    return {
        deleteObjects: action,
        renderedDialog: renderedDialog,
    };
}
exports.default = useDeleteObjects;
